exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js??ref--6-oneOf-1-1!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/src/index.js??ref--6-oneOf-1-2!../../style/drivers.css"), "");

// module
exports.push([module.id, "\nspan i[data-v-e112f644] {\r\n  font-size: large;\r\n  padding: 10px;\r\n  cursor: pointer;\n}\nspan i[data-v-e112f644]:hover {\r\n  background-color: #00BFD7;\r\n  border-radius: 5px;\r\n  color: white;\n}\nspan i[data-v-e112f644]:active {\r\n  -webkit-box-shadow: 0px 0px 10px #00BFD7;\r\n          box-shadow: 0px 0px 10px #00BFD7;\r\n  border-radius: 5px;\n}\r\n", ""]);

// exports
